{
  "+/na8S": "{experienceLevel} 채용 공고",
  "+RBfjK": "<strong>정부 당국</strong> - 법률, 규정 또는 법적 절차에 따라 요구되는 경우.",
  "+lsg50": "<strong>거래 관련 커뮤니케이션:</strong> 지원 상태 업데이트, 면접 알림, 입사 안내 및 지원 또는 채용과 직접 관련된 기타 정보(동의 선택에 따라 SMS, 이메일 또는 전화로 전송)",
  "/GKTwV": "{startResult} - {endResult} / {totalCount}",
  "/SZPmm": "직책 또는 키워드로 검색하세요",
  "/pdLnE": "<strong>삭제 요청권:</strong> 귀하는 특정 법적 예외 사항(예: 기록 보관 의무)을 제외하고 당사에 귀하의 개인 정보 삭제를 요청할 수 있습니다.",
  "00m1vT": "<strong>자동으로 수집된 데이터:</strong> 당사 플랫폼 제공업체의 표준 데이터 보존 정책에 따라 보관됩니다.",
  "06JQuf": "5. 보증 면책 조항",
  "0uj8CA": "(마케팅) 분야에서 지원 가능한 직무 기회 및 직책",
  "0xKvFl": "<strong>접근권:</strong> 귀하는 당사가 보유하고 있는 귀하의 개인 정보 사본을 요청할 수 있습니다.",
  "1MNiI4": "{name}선택하세요",
  "1QOHHT": "근무 시간",
  "1WIMxg": "취소",
  "1ma4gO": "당사는 귀하가 당사 채용 사이트를 이용할 때 다음과 같은 범주의 개인 정보를 수집할 수 있습니다.",
  "2YzWOm": "신청",
  "2gDsJ9": "검색 및 필터를 조정해 주세요.",
  "2ysiB3": "모든 필터 지우기",
  "3CLJU9": "다음 연락처로 문의하세요: <supportLink>{supportContact}</supportLink>",
  "3NW9w+": "{accountName} 개인정보 보호정책",
  "3RG7Do": "6. 귀하의 권리와 선택",
  "3Yr6Zd": "1. 본 사이트 이용",
  "3oHMyk": "거주 지역에 따라 개인 정보와 관련하여 다음과 같은 권리를 가질 수 있습니다.",
  "3qpbhl": "10. 데이터 보안",
  "3v8etI": "{position} 채용 공고",
  "41OEjv": "저희는 지원서 양식을 통해 직접 개인 정보를 수집하고, 플랫폼 제공업체의 기술(채용 사이트에 내장된 쿠키 및 유사 기술)을 통해 자동으로 개인 정보를 수집합니다.",
  "4ohioF": "<strong>플랫폼 운영:</strong> 당사는 플랫폼 제공업체(Fountain)에게 당사를 대신하여 채용 사이트의 보안 및 기능을 유지 관리하고, 사기 행위를 탐지하고 기술적 문제를 해결할 권한을 부여합니다.",
  "56kYFg": "<strong>지원 관련 SMS:</strong> 상태 업데이트, 면접 알림, 온보딩 지침 및 {accountName} 에 대한 지원 또는 고용과 직접 관련된 기타 메시지. <em>(거래 관련)</em>",
  "5c0xwM": "탈퇴를 선택하신 후에는 확인 메시지를 한 번 받게 됩니다. 채용 사이트를 통해 재등록하거나 당사 메시지에 START라고 답장하여 문자를 보내면 다시 구독할 수 있습니다.",
  "6I7QkP": "현지의",
  "6gJsj3": "개인정보 처리방침",
  "7EUdCR": "저희 채용 사이트를 통해 지원서를 제출하시면, 귀하의 개인 정보는 저희 플랫폼 제공업체(Fountain)가 저희를 대신하여 직접 수집합니다. 당사는 채용 절차 운영을 지원하는 다음과 같은 서비스 제공업체와 귀하의 개인 정보를 공유할 수 있습니다.",
  "7HOdgz": "{location} 주변 채용 공고가 없습니다",
  "7K2KnA": "필터",
  "7O1CGZ": "본 개인정보 보호정책에 대해 궁금한 점이 있거나 귀하의 권리를 행사하고자 하는 경우, 당사에 문의해 주십시오.",
  "7srJEb": "{brandName}에서 당신의 다음 기회를 찾아보세요",
  "8R2FQ7": "신청",
  "8YcgIg": "/년도",
  "8lJb89": "시행일: 2026년 4월",
  "8moA7E": "신청서에서 수신 동의란을 선택하시면, 제공하신 전화번호로 {accountName} 에서 발송하는 SMS 문자 메시지를 수신하는 데 동의하시는 것입니다. 메시지에는 다음 내용이 포함될 수 있습니다.",
  "9Jg0WQ": "정렬 기준",
  "9TzuJX": "위치",
  "9ZVuvw": "<supportLink>{supportContact}</supportLink>",
  "9fotW7": "탈퇴 방법:",
  "9gvBvK": "직무 유형",
  "A939ot": "지우기",
  "AEkpsv": "영구적인",
  "AXM0Ru": "개인정보 처리방침",
  "Af+l/5": "{count, plural, other {{count,number}개의 일자리가 있습니다.}}",
  "AkOXuk": "<strong>기기 및 사용 데이터:</strong> IP 주소, 브라우저 유형, 기기 식별자, 운영 체제 및 IP 주소를 기반으로 추정한 대략적인 위치 정보",
  "Apa4NB": "11. 아동의 개인정보 보호",
  "BwwT2Q": "<strong>상호작용 데이터:</strong> 당사 채용 사이트에서 방문한 페이지, 체류 시간 및 지원 절차 내에서 취한 조치",
  "C/40b0": "직책을 선택하세요",
  "C5OA4b": "위에 설명된 목적을 위해 더 이상 귀하의 개인 정보가 필요하지 않게 되면, 당사는 해당 데이터 보존 및 폐기 절차에 따라 플랫폼 제공업체와 협력하여 해당 정보를 안전하게 삭제하거나 식별 불가능하게 처리할 것입니다.",
  "CIaoJm": "작업자 로그인",
  "CfEcpR": "<strong>차별 금지 권리:</strong> 당사는 귀하가 개인정보 보호 권리를 행사하는 것을 이유로 차별하지 않습니다.",
  "DTxAgM": "<strong>알 권리:</strong> 귀하는 당사가 귀하에 대해 수집한 개인 정보의 범주 및 구체적인 항목, 해당 정보의 출처, 수집 목적, 그리고 해당 정보를 공유한 제3자의 범주에 대한 정보를 요청할 수 있습니다.",
  "DaFtVe": "<strong>신원조회 서비스 제공업체</strong> — 채용 절차가 진행되고 귀하가 별도의 동의를 제공하는 경우, 당사는 제3자 서비스 제공업체와 정보를 공유하여 신원조회를 실시할 수 있습니다.",
  "E+ZmsH": "당사의 채용 웹사이트는 플랫폼 제공업체(Fountain)를 통해 운영되며, 섹션 2에 설명된 기기 및 사용 데이터를 수집하기 위해 쿠키 및 유사 기술을 사용합니다. 이러한 기술은 Fountain이 당사를 대신하여 채용 웹사이트를 운영하고, 사용량을 분석하고, 성능을 개선하기 위해 배포합니다. 당사 채용 사이트에 사용되는 특정 쿠키에 대한 자세한 정보는 Fountain의 개인정보 보호정책을 참조하십시오.<fountainPrivacyLink>fountain.com/privacy</fountainPrivacyLink>.",
  "E2+MeX": "<strong>추적 금지 신호:</strong> 당사 채용 사이트는 현재 &quot;추적 금지&quot;(DNT) 브라우저 신호에 응답하지 않습니다. 현재로서는 DNT(Do Not Track) 신호를 인식하거나 존중하는 데 있어 업계에서 통용되는 표준은 없습니다.",
  "ECDDUw": "탈퇴를 선택하시면 신속하게 요청을 처리해 드리겠습니다. 마케팅 메시지 수신을 거부하더라도, 현재 진행 중인 지원 또는 고용 관계와 관련된 거래 메시지에는 영향을 미치지 않습니다. 단, 해당 메시지 수신을 별도로 거부하는 경우는 예외입니다.",
  "EJyETf": "신청 과정에서 다음과 같은 각 유형의 연락에 대해 별도의 동의를 요청받을 수 있습니다.",
  "EZ7l60": "거리를 선택하세요",
  "F4rSq/": "<strong>메시지 빈도:</strong> 메시지 빈도는 애플리케이션 상태 및 활동에 따라 다릅니다. 표준 메시지 및 데이터 요금이 적용될 수 있습니다.",
  "FD+Ak4": "필터",
  "FbMyuc": "<strong>문자 메시지 수신 동의 기록:</strong> 문자 메시지 수신에 동의하신 경우, 동의 선택 내역을 수집 및 보관합니다.",
  "Fza3xO": "{count, plural, other {{query} 에 {count,number}개의 일자리가 있습니다(모든 지역)}}",
  "G3uSr3": "정렬 기준:",
  "GLUAB+": "{category}의 채용 공고",
  "GiGPOp": "<strong>지원서 처리:</strong> 자격 평가, 면접 일정 조정, 신원 조사(필요한 경우 별도 동의 필요), 지원서 진행 상황 안내",
  "GnfGtK": "본 정책을 정기적으로 검토하시기를 권장합니다. 변경 사항이 게시된 후에도 당사 채용 사이트를 계속 이용하시는 것은 그 자체로 개정된 약관에 동의하는 것으로 간주되지 않습니다. 동의가 필요한 모든 처리는 별도의 동의 절차를 거쳐야 합니다.",
  "GoyAbs": "\"{query}\"에 대한 검색 결과",
  "Gx/VZ8": "정규직",
  "HjtQ1S": "<strong>당사는 귀하의 개인 정보를 판매하지 않습니다. 또한, 당사는 귀하의 개인 정보를 다양한 맥락에 맞춘 행동 광고를 위해 공유하지 않습니다.</strong>",
  "IPBVH3": "9. 쿠키, 추적 기술 및 추적 금지",
  "J4l/AQ": "행정 및 전문",
  "J8cmAm": "더 보기({count})",
  "JC1ICT": "보상 유형",
  "Jlcabf": "<strong>민감한 개인 정보:</strong> 직책 및 관련 법률에 따라 고용 확인 또는 신원 조사 목적으로 정부 발행 신분증 번호(예: 사회 보장 번호 또는 운전면허증 번호)를 수집할 수 있습니다. 당사는 법률에서 허용하는 특정 목적을 위해서만 민감한 개인 정보를 처리하며, 프로파일링이나 광고 목적으로 사용하지 않습니다. 캘리포니아 주민은 당사의 민감한 개인 정보 사용을 제한할 권리가 있습니다. 자세한 내용은 6항을 참조하십시오.",
  "JtmXU+": "검색 {name}",
  "KDjhll": "EU/EEA 또는 영국에서 미국으로 개인 정보를 전송하는 경우, 당사는 다음과 같은 보호 조치를 적용합니다. (a) 적용 가능한 경우 EU-미국 데이터 개인정보 보호 프레임워크(DPF) 및/또는 (b) 서비스 제공업체와의 데이터 처리 계약에 포함된 유럽 위원회에서 승인한 표준 계약 조항(SCC). 적용되는 보호 조치의 사본을 요청하시려면 당사에 연락해 주십시오.<supportLink>{supportContact}</supportLink>.",
  "KrXS5/": "수신 거부를 원하시면 저희가 보내드리는 문자 메시지에 'STOP'이라고 답장해 주세요.",
  "L1t2kd": "메시지 전송 빈도는 다양합니다. 메시지 및 데이터 요금이 부과될 수 있습니다.",
  "LOXUJb": "사용되는 쿠키 유형:",
  "Lbwy5v": "직무명",
  "LtyZus": "<strong>채용 기회 SMS:</strong> 귀하가 지원할 수 있는 {accountName} 의 다른 직책에 대한 정보입니다. <em>(마케팅 목적 - 별도 동의 필요)</em>",
  "MCzo6Q": "<strong>채용 기회 관련 전화:</strong> 귀하가 지원할 자격이 있을 수 있는 {accountName} 의 다른 직책에 대한 전화입니다. <em>(마케팅 목적 - 별도 동의 필요)</em>",
  "Mf37lr": "상위 카테고리",
  "Mh1F+e": "{count, plural, other {원격 근무 일자리 {count,number}개를 찾았습니다.}}",
  "NG6g7y": "반경",
  "Nkxa4f": "모든 서비스 제공업체는 계약상 귀하의 정보를 보호하고, 당사가 지정한 목적에만 사용하며, 서비스 제공에 필요한 기간을 초과하여 정보를 보유하지 않아야 할 의무가 있습니다.",
  "OpSpNa": "당사는 귀하가 요청한 서비스 제공, 지원서 처리 및 평가, 고용 관계 지원, 법적 및 규제 의무 준수, 분쟁 해결 등 수집 목적을 달성하는 데 필요한 합리적인 기간 동안 귀하의 개인 정보를 보유합니다.",
  "OuE0df": "<strong>판매/공유 거부 권리:</strong> 당사는 귀하의 개인 정보를 다양한 맥락에 맞춘 행동 광고 목적으로 판매하거나 공유하지 않습니다. 당사는 이러한 관행에 관여하지 않으므로 별도의 거부 절차가 필요하지 않습니다.",
  "OxK884": "재무 및 회계",
  "PkU5jD": "<strong>모든 채널:</strong> 문의하기 <supportLink>{supportContact}</supportLink> 모든 커뮤니케이션 채널에서 동의 설정을 업데이트하거나 철회할 수 있습니다.",
  "Q43kt/": "<strong>지원 관련 전화:</strong> 지원 상태, 면접 일정 및 입사 절차와 관련된 전화입니다. <em>(거래 관련)</em>",
  "QHXX/I": "<strong>통신 서비스 제공업체</strong> - 문자 메시지 및 전화 통화를 전달하는 데 필요한 전화 통신 사업자 및 메시지 서비스 제공업체. 당사는 귀하의 SMS 수신 동의 여부를 포함한 개인 정보를 당사의 메시징 서비스 제공을 지원하는 제3자(플랫폼 제공업체, 통신 회사 및 문자 메시지 전송을 지원하는 기타 공급업체를 포함하되 이에 국한되지 않음)와 공유할 수 있습니다. 이 정보 공유는 서비스 제공 목적으로만 이루어집니다.",
  "Qc+F6I": "각 동의 선택은 <strong>독립적</strong> 입니다. 이러한 커뮤니케이션 유형 중 일부 또는 전부를 수신하거나 전혀 수신하지 않을 수도 있습니다. 귀하의 선택은 지원서에 영향을 미치지 않습니다.",
  "Qjh8MV": "<strong>도움을 받는 방법:</strong> 문자 메시지에 <strong>HELP</strong> 라고 답장하거나 다음 연락처로 문의하세요.<supportLink>{supportContact}</supportLink>.",
  "QmFp6b": "<strong>Fountain, Inc.</strong> — 당사의 채용 플랫폼 제공업체입니다. Fountain은 당사를 대신하여 귀하의 개인 정보를 수집 및 처리하여 지원 절차를 원활하게 진행하고, SMS 및 기타 안내를 전달하며, 채용 프로세스를 관리합니다. Fountain의 개인정보 보호정책은 다음에서 확인할 수 있습니다.<fountainPrivacyLink>fountain.com/privacy</fountainPrivacyLink>.",
  "R+laqn": "카테고리",
  "R5pOCA": "아래에서 {brandName}의 진행 중인 모든 채용 공고를 확인하거나, 다른 지역의 공고를 검색하세요.",
  "RdNN/i": "어느",
  "RhRgl7": "<strong>정정권:</strong> 귀하는 부정확한 개인 정보의 정정을 요청할 수 있습니다.",
  "RwsNjX": "2. SMS 메시지 프로그램",
  "ShbUPK": "도시",
  "T0z9P/": "{count, plural, other {{radius} {unit} {location}내에서 {count,number}개의 일자리를 찾았습니다.}}",
  "TBEZ9x": "채용 공고 이름",
  "TuoZCm": "다음 기회를 찾으십시오",
  "UKI/HU": "모두",
  "Ud728E": "관련 법률이 허용하는 최대 범위 내에서 {accountName} 은 귀하의 본 사이트 또는 당사의 SMS 프로그램 사용으로 인해 발생하는 간접적, 부수적, 특별 또는 결과적 손해에 대해 책임을 지지 않습니다.",
  "V/osST": "현재 위치",
  "VC3i9i": "본 사이트 및 그 내용은 어떠한 종류의 명시적 또는 묵시적 보증 없이 \"있는 그대로\" 제공됩니다. 당사는 사이트가 중단 없이 또는 오류 없이 운영될 것을 보장하지 않습니다.",
  "VcjP63": "귀하의 개인 정보는 당사 플랫폼 제공업체인 Fountain이 주요 인프라를 운영하는 미국으로 전송되어 처리될 수 있습니다. 미국은 귀하의 거주 국가와 동일한 수준의 데이터 보호를 제공하지 않을 수 있습니다.",
  "VguvIP": "{count, plural, other {{query}에 {count,number}개의 일자리가 있습니다.}}",
  "VoPWLM": "검색 카테고리",
  "Vvd1rH": "당사는 본 약관을 주기적으로 업데이트할 수 있습니다. 변경 사항이 게시된 후에도 이 사이트를 계속 사용하는 것은 개정된 약관에 동의하는 것으로 간주됩니다.",
  "WT6YVK": "이전",
  "WjwoSF": "<strong>SMS 동의 기록:</strong> 통신사 및 FCC의 기록 보관 요건에 따라 규제 준수 목적으로 최소 5년 동안 보관합니다.",
  "WuHcvG": "저희 채용 사이트는 인력 관리 플랫폼인 <strong>Fountain, Inc.</strong> (“Fountain”)에서 운영하며, Fountain은 저희 서비스 제공업체로서 귀하의 개인 정보를 처리합니다. Fountain은 데이터 처리자 역할을 하며, 당사는 귀하의 개인 정보가 처리되는 방식과 이유를 결정하는 데이터 관리자입니다.",
  "X1Y9Ps": "채용 공고 이름으로 검색",
  "XPamEN": "/시간",
  "XcuBSu": "진행 중인 모든 채용 공고",
  "XjSvOF": "운영 및 리더십",
  "YDhGHb": "7. 데이터 보존",
  "YQbDhN": "이용 약관",
  "YbL2yB": "<strong>고용 정보:</strong> 근무 경력, 학력, 기술, 자격증 및 지원서 질문에 대한 답변",
  "Yoy6Jy": "아래에서 {brandName}의 진행 중인 모든 채용 공고를 확인하거나, 다른 지역의 공고를 검색하세요.",
  "Z4YDPm": "<strong>지원서 정보:</strong> 채용이 확정되면 지원서 정보는 고용 관계가 지속되는 기간 동안 그리고 관련 고용, 세금 및 기록 보관 법규에서 요구하는 합리적인 기간 동안 보관됩니다. 채용되지 않은 경우, 귀하의 지원 정보는 일반적으로 향후 채용 기회를 고려하고 법률 및 규제 요건을 준수하기 위해 특정 기간 동안 보관됩니다. 단, 법률에 따라 더 짧거나 더 긴 보관 기간이 요구되는 경우는 예외입니다.",
  "a37+C1": "지원 상태 업데이트, 입사 정보 및 기타 고용 관련 알림(거래 알림)",
  "aD7/QV": "파트타임",
  "aKWnwv": "페이지",
  "aaT0rw": "귀하가 당사 채용 사이트를 방문하시면, 당사의 플랫폼 제공업체(Fountain)가 당사를 대신하여 쿠키 및 유사 기술을 사용하여 특정 정보를 자동으로 수집합니다. 다음 사항이 포함될 수 있습니다:",
  "avRBAo": "게시일",
  "bQxKXO": "재택 근무",
  "c0TwrW": "채용 공고 이름이나 위치로 검색",
  "cP462m": "{count, plural, other {{count,number}개 일자리 공고 (모든 지역)}}",
  "cScov5": "<strong>문자 메시지:</strong> 모든 문자 메시지에 <strong>STOP이라고</strong> 답장하세요. 'STOP'이라고 답장하면 해당 번호에서 오는 <strong>모든 SMS 메시지 수신이</strong> 거부됩니다. 특정 카테고리(예: 마케팅 SMS는 수신 거부하지만 거래 SMS는 수신 거부)만 수신 거부하고 싶으시면 저희에게 문의해 주세요.<supportLink>{supportContact}</supportLink> 설정을 세부적으로 업데이트하려면.",
  "ccduZH": "<strong>EU/EEA/영국 신청자:</strong> ePrivacy 지침(지침 2002/58/EC) 또는 영국 개인정보 및 전자통신 규정(PECR)에 따라 필요한 경우, 필수적이지 않은 쿠키를 설치하기 전에 귀하의 동의를 얻을 것입니다. 브라우저 설정을 통해 쿠키 기본 설정을 관리할 수 있습니다.",
  "cnNa4F": "귀하의 개인 정보는 당사 플랫폼 제공업체(Fountain)를 통해 처리되므로, 귀하의 요청을 이행하기 위해 Fountain과 협력할 수 있습니다. 이는 귀하가 당사에 직접 요청을 제출할 권리에 영향을 미치지 않으며, 당사는 관련 법률에서 요구하는 기한 내에 귀하에게 답변할 책임이 있습니다.",
  "coNrE4": "<strong>전화:</strong> 발신자에게 전화를 끊고 싶다고 알리거나, 저희에게 연락하십시오.<supportLink>{supportContact}</supportLink>.",
  "ctMrd+": "<strong>휴대전화 번호 및 SMS 수신 동의 데이터 등 어떠한 모바일 정보도 제3자 또는 계열사와 마케팅 또는 홍보 목적으로 공유되지 않습니다.</strong> 다른 모든 범주에서는 문자 메시지 발신자의 수신 동의 데이터 및 동의 여부가 제외됩니다. 이 정보는 어떠한 제3자에게도 공유되지 않습니다.",
  "dHKLYk": "저희와 채팅하세요",
  "dINcE1": "채용 공고 검색",
  "dMBRRH": "내부 채용 사이트",
  "dSrjr/": "본 개인정보 보호정책은 <strong>{accountName}</strong> (“당사”, “저희” 또는 “우리”)이 당사 채용 사이트를 통해 채용 공고에 지원하실 때 귀하의 개인정보를 수집, 사용 및 보호하는 방법을 설명합니다.",
  "eN7CVI": "8. 본 약관의 변경",
  "ePJ10M": "거리",
  "eWWpS5": "우주선",
  "ejsFwD": "6. 책임 제한",
  "eoLsYT": "일자리를 찾을 수 없습니다.",
  "epJ7rX": "1. 우리는 누구인가",
  "esYqDb": "13. 문의하기",
  "f5ZXVy": "본 약관은 델라웨어 주법에 따라 해석 및 적용되며, 법률 충돌 조항은 적용되지 않습니다. 본 약관에 따라 발생하는 모든 분쟁은 델라웨어 주에 소재한 주 및 연방 법원의 전속 관할에 따릅니다.",
  "f5xlBv": "{count, plural, other {{location}근처에서 {count,number}개의 일자리를 찾았습니다.}}",
  "f9XZvs": "이용 약관",
  "fHwoN4": "<strong>휴대전화 번호, SMS 수신 동의 여부, 동의 데이터 등 어떠한 모바일 정보도 제3자 또는 계열사에 마케팅 또는 홍보 목적으로 공유, 판매 또는 대여되지 않습니다.</strong> 모바일 수신 동의 및 승인 정보는 귀하가 요청한 메시지를 전달하는 데 필요한 경우에만 통신 서비스 제공업체(예: 이동통신사 및 메시징 플랫폼 업체)와 공유되며, 제3자의 독립적인 마케팅 목적으로는 절대 공유되지 않습니다.",
  "fqbMOd": "위치",
  "fz8Tvp": "<strong>필수 쿠키:</strong> 채용 사이트 운영에 필수적입니다(예: 세션 관리, 보안). 이 기능은 비활성화할 수 없습니다.",
  "gKKaX9": "문자 메시지 수신 동의는 채용 지원 또는 채용 조건이 아닙니다.",
  "ggOC46": "Fountain 플랫폼의 데이터 처리 방식에 대해 구체적인 질문이 있으시면 Fountain 개인정보보호팀에 문의하실 수도 있습니다. <privacyMailLink>privacy@fountain.com</privacyMailLink>",
  "h8XXuO": "5. 정보 공유 방식",
  "hCJFEI": "8. EU/EEA/영국 신청자의 경우: 국제 데이터 전송",
  "hNt7Xn": "검색",
  "hph9/b": "3. 정보 활용 방법",
  "iVSyX5": "어느",
  "iwEvY/": "<strong>식별 정보:</strong> 이름, 이메일 주소, 전화번호, 우편 주소",
  "jPYzxK": "2. 수집하는 정보",
  "jW9g8Q": "/월",
  "jjNqku": "위치 선택",
  "kDYV94": "원격, 재택근무, 원격근무",
  "kFJ1hG": "지우기",
  "ki+WBr": "/낮",
  "kkx0Di": "{count, plural, other {{query}에 대한 원격 근무 일자리 {count,number}개가 발견되었습니다.}}",
  "lDKw0M": "<strong>온보딩:</strong> 채용 제안을 받으신 경우, 서류 수집, 교육 일정 수립 및 오리엔테이션을 포함한 온보딩 프로세스를 지원합니다.",
  "lwRtGv": "검색 위치",
  "mOqk1N": "<strong>민감한 개인 정보 사용 제한 권리:</strong> 당사가 민감한 개인 정보(예: 사회 보장 번호 또는 정부 발행 신분증)를 수집하는 경우, 귀하는 당사가 해당 정보를 귀하가 합리적으로 기대하는 서비스를 제공하는 데 필요한 목적으로만 사용하도록 제한할 권리가 있습니다. 이 권리를 행사하려면 저희에게 연락하십시오.<supportLink>{supportContact}</supportLink>.",
  "mqm7rH": "<strong>분석 쿠키:</strong> 지원자들이 채용 사이트와 어떻게 상호작용하는지 파악하는 데 도움이 됩니다. 이러한 정보는 제3자 분석 서비스에서 제공될 수 있습니다.",
  "mvv/A1": "내 주변 채용 공고({location})",
  "n/WRpL": "{location} 주변 채용 공고를 찾을 수 없습니다",
  "n4YEE0": "지우기",
  "nUNDHI": "저희는 고객님의 개인정보 보호를 위해 합리적인 조치를 취하고 있습니다. 귀하의 데이터는 당사의 플랫폼 제공업체(Fountain)를 통해 처리되므로, 당사는 Fountain의 기술적 및 조직적 보안 제어를 활용합니다. 이러한 보안 제어에는 SOC 2 Type II 인증, ISO 27001:2022 인증, 전송 중 데이터 암호화(TLS 1.2 이상) 및 저장 데이터 암호화(AES-256)가 포함됩니다. 저희는 Fountain과 데이터 처리 계약을 체결했으며, 해당 계약에 따라 Fountain은 귀하의 개인 정보를 보호하기 위해 적절한 보안 조치를 시행해야 합니다.",
  "nUYXYf": "계약직/프리랜서",
  "nrL6lE": "더 보기({count})",
  "ntF3q4": "<strong>대리인 지정:</strong> 귀하는 본인을 대신하여 개인정보 보호 요청을 제출할 대리인을 지정할 수 있습니다. 대리인은 귀하의 권한을 증명하는 서류(예: 서명된 서면 허가서 또는 위임장)를 제출해야 하며, 당사는 귀하의 신원을 직접 확인하도록 요청할 수도 있습니다.",
  "nxt8Qc": "카테고리를 선택하세요",
  "o5G5gO": "위치별 검색",
  "o5Lr3P": "<strong>법률 준수:</strong> 기록 보관, 세금 신고, 고용 자격 확인 및 정부 당국의 적법한 요청에 대한 응답을 포함하여 당사의 법적 의무를 이행합니다.",
  "oV4vX7": "진행 중인 채용 공고",
  "oojjh4": "{accountName} (“저희”, “우리” 또는 “당사”)이 운영하는 사이트를 이용함으로써 귀하는 본 서비스 약관에 동의하게 됩니다.",
  "pCgcIl": "당사는 귀하의 개인 정보를 다음과 같은 목적으로 사용합니다.",
  "pXg8OU": "<strong>마케팅 커뮤니케이션:</strong> 별도로 동의하신 경우, 귀하가 지원 자격이 있을 수 있는 다른 채용 기회에 대한 정보를 보내드립니다.",
  "pfzWdN": "평상복",
  "pjY7EJ": "<strong>제출 서류:</strong> 이력서, 정부 발행 신분증(고용 확인을 위해 필요한 경우), 그리고 지원 또는 입사 과정 중에 업로드하는 기타 서류",
  "poL3TM": "이메일: <supportLink>{supportContact}</supportLink>",
  "puJXDp": "3. 도움을 받는 방법",
  "qt4wYG": "{accountName} 개인정보 보호정책",
  "r1QaDh": "전송이나 저장 방식에 있어 완전히 안전한 방법은 없습니다. 저희는 고객님의 개인 정보를 보호하기 위해 최선을 다하고 있지만, 절대적인 보안을 보장할 수는 없습니다.",
  "r7Kb/z": "사용 가능한 옵션이 없습니다",
  "rUGq0i": "국가/지역",
  "rdOcXL": "로그아웃",
  "rth6q8": "필터",
  "s0o3E7": "{brandName}에서 채용 공고를 검색하십시오",
  "sEzBNV": "<strong>문자 메시지나 전화를 수신하는 것에 대한 동의는 전적으로 자발적이며, 구직 신청이나 채용의 조건이 아닙니다.</strong> 수신 거부를 선택하시는 경우, 이메일을 통해 연락드리겠습니다.",
  "sR3x84": "연수생",
  "sox8LY": "당사는 본 개인정보 보호정책을 수시로 업데이트할 수 있습니다. 당사가 귀하의 개인 정보를 처리하는 방식에 중대한 변경 사항이 있을 경우, (a) 당사 채용 사이트에 눈에 띄게 공지하고, (b) 가능한 경우 등록된 연락처 정보를 통해 현재 지원 중인 지원자에게 알립니다. 개정된 정책에는 수정된 시행일이 명시될 것입니다.",
  "stlhl5": "<strong>캘리포니아 거주자 여러분:</strong> 캘리포니아 소비자 개인정보 보호법(CCPA) 및 캘리포니아 개인정보 보호 권리법(CPRA)에 따라, 여러분은 위에 나열된 모든 권리를 보유합니다. 검증 가능한 소비자 요청을 제출하려면 다음 연락처로 문의하십시오.<supportLink>{supportContact}</supportLink>. 법률에 따라 요청을 처리하기 전에 귀하의 신원을 확인하며 45일 이내에 답변드리겠습니다.",
  "syNys9": "{count, plural, other {{query} 에 대해 {radius} {unit} {location}내에서 {count,number}개의 일자리가 발견되었습니다.}}",
  "tIQhbD": "고객 서비스 및 운영",
  "tXdMLm": "저희 채용 웹사이트는 16세 미만 아동을 대상으로 하지 않습니다. 당사는 16세 미만 아동의 개인 정보를 고의로 수집하지 않습니다. 저희가 아동의 정보를 수집했다고 생각되시면 저희에게 연락해 주십시오.<supportLink>{supportContact}</supportLink> 그러면 저희가 즉시 삭제할 수 있습니다.",
  "tYpw2s": "{location} 주변 채용 공고",
  "tbs+f9": "{accountName} 개인정보 보호정책 및 서비스 약관",
  "tdTJ7T": "4. 탈퇴 방법",
  "toqXyd": "이용 약관",
  "tsGjFK": "마일",
  "uMkyWa": "귀하가 직접 제공하는 정보:",
  "uq79O0": "위치 이름",
  "uy6hZs": "도",
  "w3RZCZ": "채용 공고",
  "w7EwgX": "12. 본 개인정보 처리방침의 변경",
  "wWh0//": "{count, plural, other {{query} 근처에서 {location}에 해당하는 일자리 {count,number}개를 찾았습니다.}}",
  "wdw5oL": "9. 문의하기",
  "wqAadg": "지역",
  "x+3jJQ": "킬로미터",
  "xUezuu": "보존 기간은 당사 플랫폼 제공업체(Fountain)의 기능 및 구성에 따라 달라집니다. 구체적인 보존 기간에 대해 궁금한 점이 있으면 저희에게 문의해 주세요.<supportLink>{supportContact}</supportLink>.",
  "xbL6qz": "7. 준거법",
  "xgBjTg": "정보 기술",
  "yIC7Pq": "{lastPage}의",
  "yJcC0I": "4. 문자 메시지 및 전화 통신 프로그램",
  "yfcesY": "당사 플랫폼 제공업체를 통해 자동으로 수집되는 정보:",
  "zBwVKO": "재택 근무",
  "zKRBxT": "이 사이트는 {accountName} 에서 구직 신청 및 고용 관련 소통을 용이하게 하기 위해 운영합니다. 귀하는 본 사이트를 합법적인 목적으로만 사용하고 본 약관을 준수할 것에 동의합니다.",
  "zPvAKV": "임시",
  "zabbLE": "다음"
}
